/*
form is where we have all the details for all the inputs
for the entity forms
each entity has their own form
*/
export const form = [
  {
    name: 'transaction_type',
    value: '',
    id: 'transaction-type',
    html: '',
    type: 'multiselect',
    options: [
      { value: 'asset_disposal', text: 'Asset Disposal' },
      { value: 'bank_fees', text: 'Bank Fees' },
      { value: 'bounced_check', text: 'Bounced Check' },
      { value: 'card_payment', text: 'Credit Card Payment' },
      { value: 'depreciation', text: 'Depreciation' },
      { value: 'equity_deposit', text: 'Equity Deposit' },
      { value: 'equity_withdrawal', text: 'Equity Withdrawal' },
      { value: 'loan_issued', text: 'Loan Issued' },
      { value: 'loan_issued_payment', text: 'Loan Issued Payment' },
      { value: 'loan_payment', text: 'Loan Payment' },
      { value: 'loan_received', text: 'Loan Received' },
      { value: 'operating_expense', text: 'Operating Expense' },
      { value: 'other_income', text: 'Other Income' },
      { value: 'other_receivable', text: 'Other Receivable' },
      { value: 'asset_purchase', text: 'Purchase Fixed Asset' },
      { value: 'account_transfer', text: 'Transfer Between Accounts' },
    ],
    required: true,
  },

  // Transfer Between Accounts
  {
    name: 'tba_fromAccount',
    transactionType: 'account_transfer',
    value: [],
    valueFull: '',
    id: 'transaction-tba-fromAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'tba_toAccount',
    transactionType: 'account_transfer',
    value: [],
    valueFull: '',
    id: 'transaction-tba-toAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'tba_amount',
    transactionType: 'account_transfer',
    value: '',
    id: 'transaction-tba-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'tba_bankFee',
    transactionType: 'account_transfer',
    value: '',
    id: 'transaction-tba-bankFee',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'tba_paymentMethod',
    transactionType: 'account_transfer',
    value: '',
    id: 'transaction-tba-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: true,
  },
  {
    name: 'tba_date',
    transactionType: 'account_transfer',
    value: '0000-00-00',
    date: true,
    id: 'transaction-tba-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'tba_reference',
    transactionType: 'account_transfer',
    value: '',
    id: 'transaction-tba-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'tba_memo',
    transactionType: 'account_transfer',
    value: '',
    id: 'transaction-tba-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Transfer Between Accounts

  // Purchase Fixed Asset
  {
    name: 'pfa_assetName',
    transactionType: 'asset_purchase',
    value: '',
    id: 'transaction-pfa-assetName',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'pfa_assetAccount',
    transactionType: 'asset_purchase',
    value: [],
    valueFull: '',
    id: 'transaction-pfa-assetAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'pfa_fromAccount',
    transactionType: 'asset_purchase',
    value: [],
    valueFull: '',
    id: 'transaction-pfa-fromAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'pfa_amount',
    transactionType: 'asset_purchase',
    value: '',
    id: 'transaction-pfa-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'pfa_paymentMethod',
    transactionType: 'asset_purchase',
    value: '',
    id: 'transaction-pfa-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: false,
  },
  {
    name: 'pfa_date',
    transactionType: 'asset_purchase',
    value: '0000-00-00',
    date: true,
    id: 'transaction-pfa-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'pfa_reference',
    transactionType: 'asset_purchase',
    value: '',
    id: 'transaction-pfa-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  // Detalles de depreciacion de Purchase Fixed Asset.
  {
    name: 'pfa_depreciationEnabled',
    transactionType: 'asset_purchase',
    value: '',
    id: 'transaction-pfa-depreciationEnabled',
    html: '',
    type: 'checkbox',
    required: false,
  },
  {
    name: 'pfa_depreciationMethod',
    transactionType: 'asset_purchase',
    value: '',
    id: 'transaction-pfa-depreciationMethod',
    html: '',
    type: 'multiselect',
    options: ['Straight Line'],
    required: false,
  },
  {
    name: 'pfa_salvageValue',
    transactionType: 'asset_purchase',
    value: '',
    id: 'transaction-pfa-salvageValue',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'pfa_usefulLifeMonths',
    transactionType: 'asset_purchase',
    value: '',
    id: 'transaction-pfa-usefulLifeMonths',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'pfa_depreciationStartDate',
    transactionType: 'asset_purchase',
    value: '0000-00-00',
    date: true,
    setCurrentDate: false,
    id: 'transaction-pfa-depreciationStartDate',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'pfa_depreciationExpenseAccount',
    transactionType: 'asset_purchase',
    value: [],
    valueFull: '',
    id: 'transaction-pfa-depreciationExpenseAccount',
    html: '',
    type: 'autocomplete',
    required: false,
  },
  {
    name: 'pfa_monthlyDepreciation',
    transactionType: 'asset_purchase',
    value: '',
    id: 'transaction-pfa-monthlyDepreciation',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Purchase Fixed Asset

  // Loan Received
  {
    name: 'lr_loanAccount',
    transactionType: 'loan_received',
    value: [],
    valueFull: '',
    id: 'transaction-lr-loanAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'lr_toAccount',
    transactionType: 'loan_received',
    value: [],
    valueFull: '',
    id: 'transaction-lr-toAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'lr_amount',
    transactionType: 'loan_received',
    value: '',
    id: 'transaction-lr-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'lr_paymentMethod',
    transactionType: 'loan_received',
    value: '',
    id: 'transaction-lr-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: false,
  },
  {
    name: 'lr_date',
    transactionType: 'loan_received',
    value: '0000-00-00',
    date: true,
    id: 'transaction-lr-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'lr_reference',
    transactionType: 'loan_received',
    value: '',
    id: 'transaction-lr-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'lr_memo',
    transactionType: 'loan_received',
    value: '',
    id: 'transaction-lr-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Loan Received

  // Loan Payment
  {
    name: 'lp_loanAccount',
    transactionType: 'loan_payment',
    value: [],
    valueFull: '',
    id: 'transaction-lp-loanAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'lp_fromAccount',
    transactionType: 'loan_payment',
    value: [],
    valueFull: '',
    id: 'transaction-lp-fromAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'lp_amount',
    transactionType: 'loan_payment',
    value: '',
    id: 'transaction-lp-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'lp_principal',
    transactionType: 'loan_payment',
    value: '',
    id: 'transaction-lp-principal',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'lp_interest',
    transactionType: 'loan_payment',
    value: '',
    id: 'transaction-lp-interest',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'lp_fees',
    transactionType: 'loan_payment',
    value: '',
    id: 'transaction-lp-fees',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'lp_paymentMethod',
    transactionType: 'loan_payment',
    value: '',
    id: 'transaction-lp-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: false,
  },
  {
    name: 'lp_date',
    transactionType: 'loan_payment',
    value: '0000-00-00',
    date: true,
    id: 'transaction-lp-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'lp_reference',
    transactionType: 'loan_payment',
    value: '',
    id: 'transaction-lp-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'lp_memo',
    transactionType: 'loan_payment',
    value: '',
    id: 'transaction-lp-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Loan Payment

  // Credit Card Payment
  {
    name: 'ccp_cardAccount',
    transactionType: 'card_payment',
    value: [],
    valueFull: '',
    id: 'transaction-ccp-cardAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'ccp_fromAccount',
    transactionType: 'card_payment',
    value: [],
    valueFull: '',
    id: 'transaction-ccp-fromAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'ccp_amount',
    transactionType: 'card_payment',
    value: '',
    id: 'transaction-ccp-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ccp_bankFee',
    transactionType: 'card_payment',
    value: '',
    id: 'transaction-ccp-bankFee',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'ccp_paymentMethod',
    transactionType: 'card_payment',
    value: '',
    id: 'transaction-ccp-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: false,
  },
  {
    name: 'ccp_date',
    transactionType: 'card_payment',
    value: '0000-00-00',
    date: true,
    id: 'transaction-ccp-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ccp_reference',
    transactionType: 'card_payment',
    value: '',
    id: 'transaction-ccp-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'ccp_memo',
    transactionType: 'card_payment',
    value: '',
    id: 'transaction-ccp-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Credit Card Payment

  // Equity Deposit
  {
    name: 'ed_equityAccount',
    transactionType: 'equity_deposit',
    value: [],
    valueFull: '',
    id: 'transaction-ed-equityAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'ed_toAccount',
    transactionType: 'equity_deposit',
    value: [],
    valueFull: '',
    id: 'transaction-ed-toAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'ed_amount',
    transactionType: 'equity_deposit',
    value: '',
    id: 'transaction-ed-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ed_paymentMethod',
    transactionType: 'equity_deposit',
    value: '',
    id: 'transaction-ed-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: false,
  },
  {
    name: 'ed_date',
    transactionType: 'equity_deposit',
    value: '0000-00-00',
    date: true,
    id: 'transaction-ed-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ed_reference',
    transactionType: 'equity_deposit',
    value: '',
    id: 'transaction-ed-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'ed_memo',
    transactionType: 'equity_deposit',
    value: '',
    id: 'transaction-ed-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Equity Deposit

  // Equity Withdrawal
  {
    name: 'ew_fromAccount',
    transactionType: 'equity_withdrawal',
    value: [],
    valueFull: '',
    id: 'transaction-ew-fromAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'ew_equityAccount',
    transactionType: 'equity_withdrawal',
    value: [],
    valueFull: '',
    id: 'transaction-ew-equityAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'ew_amount',
    transactionType: 'equity_withdrawal',
    value: '',
    id: 'transaction-ew-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ew_paymentMethod',
    transactionType: 'equity_withdrawal',
    value: '',
    id: 'transaction-ew-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: false,
  },
  {
    name: 'ew_date',
    transactionType: 'equity_withdrawal',
    value: '0000-00-00',
    date: true,
    id: 'transaction-ew-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ew_reference',
    transactionType: 'equity_withdrawal',
    value: '',
    id: 'transaction-ew-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'ew_memo',
    transactionType: 'equity_withdrawal',
    value: '',
    id: 'transaction-ew-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Equity Withdrawal

  // Other Receivable
  {
    name: 'ore_receivableName',
    transactionType: 'other_receivable',
    value: '',
    id: 'transaction-ore-receivableName',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ore_person',
    transactionType: 'other_receivable',
    value: '',
    id: 'transaction-ore-person',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'ore_receivableAccount',
    transactionType: 'other_receivable',
    value: [],
    valueFull: '',
    id: 'transaction-ore-receivableAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'ore_offsetAccount',
    transactionType: 'other_receivable',
    value: [],
    valueFull: '',
    id: 'transaction-ore-offsetAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'ore_amount',
    transactionType: 'other_receivable',
    value: '',
    id: 'transaction-ore-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ore_date',
    transactionType: 'other_receivable',
    value: '0000-00-00',
    date: true,
    id: 'transaction-ore-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ore_reference',
    transactionType: 'other_receivable',
    value: '',
    id: 'transaction-ore-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'ore_memo',
    transactionType: 'other_receivable',
    value: '',
    id: 'transaction-ore-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Other Receivable

  // Other Income
  {
    name: 'oi_incomeAccount',
    transactionType: 'other_income',
    value: [],
    valueFull: '',
    id: 'transaction-oi-incomeAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'oi_toAccount',
    transactionType: 'other_income',
    value: [],
    valueFull: '',
    id: 'transaction-oi-toAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'oi_amount',
    transactionType: 'other_income',
    value: '',
    id: 'transaction-oi-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'oi_paymentMethod',
    transactionType: 'other_income',
    value: '',
    id: 'transaction-oi-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: false,
  },
  {
    name: 'oi_date',
    transactionType: 'other_income',
    value: '0000-00-00',
    date: true,
    id: 'transaction-oi-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'oi_reference',
    transactionType: 'other_income',
    value: '',
    id: 'transaction-oi-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'oi_memo',
    transactionType: 'other_income',
    value: '',
    id: 'transaction-oi-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Other Income

  // Operating Expense
  {
    name: 'oe_expenseAccount',
    transactionType: 'operating_expense',
    value: [],
    valueFull: '',
    id: 'transaction-oe-expenseAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'oe_fromAccount',
    transactionType: 'operating_expense',
    value: [],
    valueFull: '',
    id: 'transaction-oe-fromAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'oe_amount',
    transactionType: 'operating_expense',
    value: '',
    id: 'transaction-oe-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'oe_paymentMethod',
    transactionType: 'operating_expense',
    value: '',
    id: 'transaction-oe-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: false,
  },
  {
    name: 'oe_date',
    transactionType: 'operating_expense',
    value: '0000-00-00',
    date: true,
    id: 'transaction-oe-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'oe_reference',
    transactionType: 'operating_expense',
    value: '',
    id: 'transaction-oe-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'oe_memo',
    transactionType: 'operating_expense',
    value: '',
    id: 'transaction-oe-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Operating Expense

  // Bank Fees
  {
    name: 'bf_expenseAccount',
    transactionType: 'bank_fees',
    value: [],
    valueFull: '',
    id: 'transaction-bf-expenseAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'bf_fromAccount',
    transactionType: 'bank_fees',
    value: [],
    valueFull: '',
    id: 'transaction-bf-fromAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'bf_amount',
    transactionType: 'bank_fees',
    value: '',
    id: 'transaction-bf-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'bf_date',
    transactionType: 'bank_fees',
    value: '0000-00-00',
    date: true,
    id: 'transaction-bf-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'bf_reference',
    transactionType: 'bank_fees',
    value: '',
    id: 'transaction-bf-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'bf_memo',
    transactionType: 'bank_fees',
    value: '',
    id: 'transaction-bf-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Bank Fees

  // Loan Issued
  {
    name: 'li_borrower',
    transactionType: 'loan_issued',
    value: '',
    id: 'transaction-li-borrower',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'li_receivableAccount',
    transactionType: 'loan_issued',
    value: [],
    valueFull: '',
    id: 'transaction-li-receivableAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'li_fromAccount',
    transactionType: 'loan_issued',
    value: [],
    valueFull: '',
    id: 'transaction-li-fromAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'li_amount',
    transactionType: 'loan_issued',
    value: '',
    id: 'transaction-li-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'li_paymentMethod',
    transactionType: 'loan_issued',
    value: '',
    id: 'transaction-li-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: false,
  },
  {
    name: 'li_date',
    transactionType: 'loan_issued',
    value: '0000-00-00',
    date: true,
    id: 'transaction-li-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'li_reference',
    transactionType: 'loan_issued',
    value: '',
    id: 'transaction-li-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'li_memo',
    transactionType: 'loan_issued',
    value: '',
    id: 'transaction-li-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Loan Issued

  // Loan Issued Payment
  {
    name: 'lip_receivableAccount',
    transactionType: 'loan_issued_payment',
    value: [],
    valueFull: '',
    id: 'transaction-lip-receivableAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'lip_toAccount',
    transactionType: 'loan_issued_payment',
    value: [],
    valueFull: '',
    id: 'transaction-lip-toAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'lip_date',
    transactionType: 'loan_issued_payment',
    value: '0000-00-00',
    date: true,
    id: 'transaction-lip-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'lip_amount',
    transactionType: 'loan_issued_payment',
    value: '',
    id: 'transaction-lip-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'lip_principal',
    transactionType: 'loan_issued_payment',
    value: '',
    id: 'transaction-lip-principal',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'lip_interest',
    transactionType: 'loan_issued_payment',
    value: '',
    id: 'transaction-lip-interest',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'lip_paymentMethod',
    transactionType: 'loan_issued_payment',
    value: '',
    id: 'transaction-lip-paymentMethod',
    html: '',
    type: 'multiselect',
    options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
    required: false,
  },
  {
    name: 'lip_note',
    transactionType: 'loan_issued_payment',
    value: '',
    id: 'transaction-lip-note',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Loan Issued Payment


  // Asset Disposal
  {
    name: 'ad_assetName',
    transactionType: 'asset_disposal',
    value: '',
    id: 'transaction-ad-assetName',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ad_assetAccount',
    transactionType: 'asset_disposal',
    value: [],
    valueFull: '',
    id: 'transaction-ad-assetAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'ad_proceeds',
    transactionType: 'asset_disposal',
    value: '',
    id: 'transaction-ad-proceeds',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'ad_bookValue',
    transactionType: 'asset_disposal',
    value: '',
    id: 'transaction-ad-bookValue',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ad_toAccount',
    transactionType: 'asset_disposal',
    value: [],
    valueFull: '',
    id: 'transaction-ad-toAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'ad_date',
    transactionType: 'asset_disposal',
    value: '0000-00-00',
    date: true,
    id: 'transaction-ad-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'ad_reference',
    transactionType: 'asset_disposal',
    value: '',
    id: 'transaction-ad-reference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'ad_memo',
    transactionType: 'asset_disposal',
    value: '',
    id: 'transaction-ad-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Asset Disposal

  // Depreciation
  {
    name: 'dep_assetAccount',
    transactionType: 'depreciation',
    value: [],
    valueFull: '',
    id: 'transaction-dep-assetAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'dep_depreciationExpense',
    transactionType: 'depreciation',
    value: [],
    valueFull: '',
    id: 'transaction-dep-depreciationExpense',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'dep_amount',
    transactionType: 'depreciation',
    value: '',
    id: 'transaction-dep-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'dep_fromDate',
    transactionType: 'depreciation',
    value: '0000-00-00',
    date: true,
    setCurrentDate: false,
    id: 'transaction-dep-fromDate',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'dep_toDate',
    transactionType: 'depreciation',
    value: '0000-00-00',
    date: true,
    setCurrentDate: false,
    id: 'transaction-dep-toDate',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'dep_date',
    transactionType: 'depreciation',
    value: '0000-00-00',
    date: true,
    id: 'transaction-dep-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'dep_memo',
    transactionType: 'depreciation',
    value: '',
    id: 'transaction-dep-memo',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Depreciation


  // Bounced Check
  {
    name: 'bc_receivepayment',
    transactionType: 'bounced_check',
    value: [],
    valueFull: '',
    id: 'transaction-bc-receivepayment',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'bc_customer',
    transactionType: 'bounced_check',
    value: '',
    id: 'transaction-bc-customer',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'bc_bouncedFrom',
    transactionType: 'bounced_check',
    value: [],
    valueFull: '',
    id: 'transaction-bc-bouncedFrom',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'bc_amount',
    transactionType: 'bounced_check',
    value: '',
    id: 'transaction-bc-amount',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'bc_date',
    transactionType: 'bounced_check',
    value: '0000-00-00',
    date: true,
    setCurrentDate: false,
    id: 'transaction-bc-date',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'bc_bankFee',
    transactionType: 'bounced_check',
    value: '',
    id: 'transaction-bc-bankFee',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'bc_feeExpenseAccount',
    transactionType: 'bounced_check',
    value: [],
    valueFull: '',
    id: 'transaction-bc-feeExpenseAccount',
    html: '',
    type: 'autocomplete',
    required: true,
  },
  {
    name: 'bc_invoiceReference',
    transactionType: 'bounced_check',
    value: '',
    id: 'transaction-bc-invoiceReference',
    html: '',
    type: 'textfield',
    required: false,
  },
  {
    name: 'bc_checkNumber',
    transactionType: 'bounced_check',
    value: '',
    id: 'transaction-bc-checkNumber',
    html: '',
    type: 'textfield',
    required: true,
  },
  {
    name: 'bc_returnReason',
    transactionType: 'bounced_check',
    value: '',
    id: 'transaction-bc-returnReason',
    html: '',
    type: 'multiselect',
    options: ['Insufficient Funds', 'Account Closed', 'Stop Payment', 'Invalid Account', 'Other'],
    required: true,
  },
  {
    name: 'bc_notes',
    transactionType: 'bounced_check',
    value: '',
    id: 'transaction-bc-notes',
    html: '',
    type: 'textfield',
    required: false,
  },
  // End Bounced Check
]

// We use this for checking changes on the form.
export const formCopy = JSON.parse(JSON.stringify(form))
